import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-area_management",
  "use": "icon-area_management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-area_management\"><path d=\"M912 532v380H112V112h800v420z m-54 207.63V590.25L609.788 858h129.843zM165 251.08v125.91L376.987 165h-125.9zM165 515v125.9L640.9 165H515z m613.906-350L165 778.91V858h46.809L858 211.81V165h-79.094zM858 349.82L349.817 858H474.99L858 469.74V349.82z\" fill=\"#ffffff\" p-id=\"2663\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/area_management.svg
// module id = PH5N
// module chunks = 39